import { apiBaseUrl } from 'configs';

import axiosClient from '@utils/axiosClient';

const fetchPrivy = axiosClient({
  baseURL: apiBaseUrl + '/api/julo_privy/v1',
});

const fetch = axiosClient({
  baseURL: apiBaseUrl + '/api',
});

export const getCustomerStatus = () =>
  fetchPrivy({
    method: 'GET',
    url: '/customer-status-privy/',
  });

export const getDocumentStatus = () =>
  fetchPrivy({
    method: 'GET',
    url: '/document-status/',
  });

export const getDocumentStatusJ1 = (payload) =>
  fetchPrivy({
    method: 'GET',
    url: `/document-status-privy/${payload.loan_xid}/`,
  });

export const documentUploadJ1 = (payload) =>
  fetchPrivy({
    method: 'POST',
    url: '/document-upload-privy/',
    body: payload,
  });

export const documentUpload = (payload) =>
  fetchPrivy({
    method: 'POST',
    url: '/document-upload/',
    body: payload,
  });

export const requestOtp = (payload) =>
  fetchPrivy({
    method: 'POST',
    url: '/request-otp/',
    body: payload,
  });

export const requestOtpJ1 = (payload) =>
  fetchPrivy({
    method: 'POST',
    url: '/request-otp-privy/',
    body: payload,
  });

export const confirmOtp = (payload) =>
  fetchPrivy({
    method: 'POST',
    url: '/confirm-otp/',
    body: payload,
  });

export const confirmOtpJ1 = (payload) =>
  fetchPrivy({
    method: 'POST',
    url: '/confirm-otp-privy/',
    body: payload,
  });

export const docSignJ1 = (payload) =>
  fetchPrivy({
    method: 'POST',
    url: '/document-sign-privy/',
    body: payload,
  });

export const docSign = (payload) =>
  fetchPrivy({
    method: 'POST',
    url: '/document-sign/',
    body: payload,
  });

export const imageReUpload = (payload, type) =>
  fetchPrivy({
    method: 'POST',
    url: `/upload-image-reupload/${type}/`,
    body: payload,
  });

export const reUploadCustomer = (payload) =>
  fetchPrivy({
    method: 'POST',
    url: '/reupload-privy-customer/',
    body: payload,
  });

export const checkMobileFeature = (featureName) =>
  fetch({
    method: 'GET',
    url: `/v2/mobile/feature-settings?feature_name=${featureName}`,
  });

export const signatureUpload = (payload, loanXid) =>
  fetch({
    method: 'POST',
    url: `/partner/grab/loan/image_upload/v1/${loanXid}`,
    body: payload,
  });
